import { Link } from 'react-router-dom';

import { Links } from 'links';

import { BaseIssuanceRetailerProductExclusion, ProductDashboardDto } from 'codegen';
import {
  InitialTableActions,
  TColumn,
  TEditableColumn,
  TFieldProps,
} from 'types';

export const columns = (products?: ProductDashboardDto[]): TEditableColumn<BaseIssuanceRetailerProductExclusion>[] => [{
  width: 250,
  title: 'Product Name',
  dataIndex: 'product.name',
  field: {
    type: TFieldProps.type.Select,
    placeholder: 'Enter product name',
    rules: [{
      message: 'Required',
      required: true,
    }],
    options: products?.map((product) => ({
      label: product.name,
      value: product.id,
    })),
  },
}, {
  width: 250,
  title: 'ID',
  dataIndex: 'product.order',
  render: (order, { product }) => {
    if (!product?.id) return null;

    return (
      <Link to={`${Links.Products}/${product.id}`}>
        {order}
      </Link>
    );
  },
}, {
  type: TColumn.type.Date,
  width: 180,
  title: 'Effective From',
  dataIndex: 'product.effectiveFrom',
  dateFormat: 'YYYY/MM/DD',
}, {
  type: TColumn.type.Date,
  width: 180,
  title: 'Effective To',
  dataIndex: 'product.effectiveTo',
  dateFormat: 'YYYY/MM/DD',
}];

export const initialTableActions = [{
  type: InitialTableActions.Delete,
}];
